import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { newsletterUpdateElement } from '../../../actions/index'
import toJS from '../../../hoc/toJS'
import {  NEWSLETTERLOCAL } from '../../../constants/state'
import EditNewsletterElement from '../present/EditNewsletterElement'


const getDataKey = itemType => 'text' === itemType ? 'texts' : 'images'


const mapStateToProps = (state, ownProps) => ({
    itemData: state.getIn([NEWSLETTERLOCAL, getDataKey(ownProps.itemType), 'items', ownProps.itemId])
})


const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateElement: (itemType, itemData) => {
        dispatch(newsletterUpdateElement(itemType, itemData))
    }
})


const EditNewsletterElementContainer = ({itemId, itemType, itemData, closePagePath, onUpdateElement}) => {
    if(!itemData) {
        return ''
    }

    return <EditNewsletterElement
        itemData={itemData}
        itemType={itemType}
        closePagePath={closePagePath}
        onUpdateItem={onUpdateElement}
    />
}


export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(EditNewsletterElementContainer)